/**
 * @return {Loading}
 * @extends {jQuery}
 */
function Loading() {
    var defaultMessage = L10N.getString('LOADING') + '...';
    var $ = jQuery;

    /**
     * @lends Loading.prototype
     */
    var loading = $('' +
        '<div class="Loading">' +
        '   <div class="progress-bar">' +
        '       <div class="bar"></div>' +
        '       <p class="label"></p>' +
        '   </div>' +
        '</div>');

    var notice;

    loading.setLabel = function (message) {
        loading.find('.label').text(message || defaultMessage);
        return loading
    };

    loading.setNotice = function (message) {
        if (!notice) {
            notice = $('<div class="notice"><p class="flash-switch"></p></div>"').prependTo(loading)
        }
        notice.find('p').text(message);
    };

    return loading;
}